import { css } from 'styled-components';
export * from './common.css';

export const section = css`
  margin: 72px 0;
  padding: 0;
`;
